<template>
  <div class='c-app flex-row align-items-center'>
    <CContainer>
      <CRow class='justify-content-center'>
        <CCol md='8'>
          <CCardGroup>
            <CCard class='p-4'>
              <CCardBody>
                <div class="text-center mb-4">
                  <img src="@/assets/smart-logo.png" alt="Smart Progress Logo" style="max-width: 150px;" />
                </div>
                <CForm @submit.prevent='UserLogin'>
                  <h1 class='text-center log-h'>تسجيل الدخول</h1>
                  <CInput placeholder='البريد الالكتروني' v-model='user.email'>
                    <template #prepend-content
                      ><CIcon name='cil-user'
                    /></template>
                  </CInput>
                  <CInput
                    placeholder='كلمة المرور'
                    type='password'
                    v-model='user.password'
                  >
                    <template #prepend-content
                      ><CIcon name='cil-lock-locked'
                    /></template>
                  </CInput>
                  <CRow>
                    <CCol col='12' class='text-center'>
                      <CButton color='primary' type='submit' class='px-4'
                        >تسجيل الدخول</CButton
                      >
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
import swal from 'sweetalert'

export default {
  name: 'Login',
  data () {
    return {
      user: []
    }
  },
  methods: {
    UserLogin: function () {
      const formData = new FormData()
      formData.append('email', this.user.email)
      formData.append('password', this.user.password)
      this.$http
        .post(`${this.$hostUrl}login`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Access-Control-Allow-Origin': '*'
          }
        })
        .then((response) => {
          if (!response.data.error) {
            localStorage.token = response.data.data.token
            this.$router.push({ name: 'الرئيسية' })
          } else {
            swal({ title: response.data.message, buttons: 'تم' })
          }
        })
        .catch(function (error) {
          if (Object.prototype.hasOwnProperty.call(error, 'response')) {
            const data = (error.response || {}).data
            if (data.error) {
              swal({ title: data.message, buttons: 'تم' })
            } else {
              swal({
                title: 'حدث خطـأ اثناء معالجة الطلب الرجاء المحاولة لاحقا',
                buttons: 'تم'
              })
            }
          } else {
            swal({
              title: 'حدث خطـأ اثناء معالجة الطلب الرجاء المحاولة لاحقا',
              buttons: 'تم'
            })
          }
        })
    }
  }
}
</script>
